import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import { z } from "zod";
import { uploadAPI } from "../../utils/uploadFetch.js";

const ResponseSchema = z.object({
  image_url: z.string(),
  thumbnail_url: z.string()
});
type Response = z.infer<typeof ResponseSchema>;

const RequestSchema = z.object({
  id: z.string(),
  file: z.instanceof(File)
});
type Request = z.infer<typeof RequestSchema>;

// V5 Pattern: Direct useMutation wrapper
export function usePostResourceAgendaUploadChecklistImage(
  options?: UseMutationOptions<Response, Error, Request>
) {
  return useMutation({
    mutationFn: async (variables: Request) => {
      return uploadAPI<Request, Response>({
        method: "POST",
        url: `/checklist/item/${variables.id}/upload`,
        requestSchema: RequestSchema,
        responseSchema: ResponseSchema,
        body: variables,
        fileKey: "file"
      });
    },
    ...options
  });
}
